import { Record, List } from 'immutable';

export const googleSearchItemFactory = new Record({
  title: '',
  link: '',
  snippet: '',
});

export const googleSearchFactory = new Record({
  items: new List(),
  googleSearchText: null,
  googlePanelStatus: false,
  isGoogleSearchLoading: false,
});

export function googleSearchItemsAdapter(items) {
  return new List(items.map(googleSearchItemFactory));
}
